module.exports = __webpack_public_path__ + "img/hz_27.f5ac9321.jpg";